import React from 'react';
import type { SingleValueProps } from 'react-select';
import { components } from 'react-select';
import TopicPermissionInfo from './TopicPermissionInfo';
import type { TopicPermissionOption } from './TopicPermissionSelectOption';
import type {
  PostLinkAccess,
  TopicMemberEditable,
  TopicPrivacy,
} from '../../graphql/generated/graphqlTypes';

interface TopicPermissionSelectValueProps<
  Value extends TopicMemberEditable | TopicPrivacy | PostLinkAccess,
  IsMulti extends boolean = false,
> extends SingleValueProps<TopicPermissionOption<Value>, IsMulti> {
  data: TopicPermissionOption<Value>;
}

const TopicPermissionSelectValue = <
  Value extends TopicMemberEditable | TopicPrivacy | PostLinkAccess,
  IsMulti extends boolean = false,
>(
  props: TopicPermissionSelectValueProps<Value, IsMulti>,
) => (
  <components.SingleValue {...props}>
    <TopicPermissionInfo {...props.data} />
  </components.SingleValue>
);

export default TopicPermissionSelectValue;
